import Logger from '@evidentid/logger';
import Tracker from '@evidentid/tracker';

import { createModuleBuilder } from '../../app';

export function createTrackRoutesModule() {
    return createModuleBuilder()
        .demandContext<{ tracker?: Tracker<any>, logger?: Logger<any> }>()
        .execute((app) => {
            app.observer.onRouteChange((route) => {
                if (app.tracker) {
                    app.tracker.track({
                        name: 'Route change',
                        // vue-router 4 types route names as `RouteRecordName = string
                        // | symbol` -- template-literal interpolation of a symbol
                        // throws at runtime (TS2731), so coerce explicitly.
                        description: `Route change: ${String(route.name || '<unknown>')}`,
                        route: route.name || '<unknown>',
                    });
                }

                if (app.logger) {
                    app.logger.setTag('route', route.name || '<unknown>');
                }
            });
        })
        .end();
}

export type TrackRoutesModule = ReturnType<typeof createTrackRoutesModule>;
